import {authStore} from '@/composables/store-accessor'

export const useAuth = to => {
    const role = authStore.person?.role,
        signInPages = ['authorization', 'b2b-auth', 'register', 'b2b-register']
    if (signInPages.includes(<string>to.name) && role) {
        return navigateTo({name: 'home'})
    } else if (!role && !signInPages.includes(<string>to.name)) {
        return navigateTo({name: 'home'})
    }
}

export default defineNuxtRouteMiddleware(useAuth)
